import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { StorageService } from '../../service/storage.service';
import { SKIP_AUTH } from '../../service/signin.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  const token = storageService.getToken();

  const apiUrl = environment.API_URL.replace(/\/+$/, '');

  const isApiRequest = req.url === apiUrl || req.url.startsWith(`${apiUrl}/`);


  if (req.context.get(SKIP_AUTH) || !token || !isApiRequest) {
    return next(req);
  }

  const authRequest = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });

  return next(authRequest);
};
